module.exports = __webpack_public_path__ + "static/crunchy_rolls_slika1-b20f06174a217c22fa44107bf09ffc41.jpg";